import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import {
	makeComplexDataTestId,
	VALUATION_ELEMENT_ID,
} from '@dealstack/shared/tests/testElementIds';
import type { BannerColumn } from './ValuationMatricsBanner.types';

interface Props {
	columns: BannerColumn[];
}

export function ValuationBanner({ columns }: Props) {
	return (
		<div
			data-testid={`${VALUATION_ELEMENT_ID.METRIC_BANNER}`}
			style={{
				padding: '0.5rem',
				backgroundColor: `${defaultTheme.v3.colors.gray[0]}`,
				border: `1px solid ${defaultTheme.v3.colors.gray[4]}`,
				borderRadius: '0.25rem',
				display: 'flex',
			}}
		>
			<div style={{ display: 'flex', gap: '1rem' }}>
				{columns.map((column, index) => (
					<div
						key={index}
						style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
					>
						<div
							data-testid={makeComplexDataTestId(
								VALUATION_ELEMENT_ID.METRIC_LABEL,
								column.label
							)}
							style={{
								fontSize: '14px',
								fontWeight: 600,
								color: `${defaultTheme.v3.colors.dark[8]}`,
								lineHeight: '20px',
								fontStyle: 'normal',
								fontFamily: 'Inter',
							}}
						>
							{column.label}
						</div>
						<div
							data-testid={makeComplexDataTestId(
								VALUATION_ELEMENT_ID.METRIC_VALUE,
								column.label
							)}
							style={{
								fontSize: '24px',
								fontWeight: 200,
								color: `${defaultTheme.v3.colors.dark[8]}`,
								lineHeight: '32px',
								fontStyle: 'normal',
								fontFamily: 'Inter',
							}}
						>
							{column.value}
						</div>
					</div>
				))}
			</div>
		</div>
	);
}
